<template>
  <rest-list-page-new
    ref="list"
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :breadcrumbs="breadcrumbs"
    :list-max-height="pageHeight"
  >
    <template slot="table">
      <rest-list-column
        prop="campaign_title"
        :title="$t('Action_Field_Campaign')"
        :min-width="300"
        :tooltip="true"
        :fixed="true"
      />

      <rest-list-column-date
        prop="create_time"
        :title="$t('Action_Field_CreateTime')"
        :fixed="true"
      />

      <rest-list-column
        prop="error"
        :title="$t('Action_Field_Warning')"
        :filter-input="false"
        :width="100"
        align="center"
      >
        <template v-slot:default="scope">
          <rest-list-action
            v-if="scope.row.error"
            icon="el-icon-warning"
            :class="errorClass(scope.row)"
            :route="rowViewRoute(scope.row)"
            :title="errorMessage(scope.row)"
          />
        </template>
      </rest-list-column>

      <rest-list-column-enum
        prop="message_type"
        :title="$t('Action_Field_MessageType')"
        :enum="formattedMessageTypeLabels"
        :min-width="150"
      />

      <rest-list-column-enum
        prop="application_id"
        :title="$t('Action_Field_Application')"
        :enum="applicationsList"
        :translate="false"
        :min-width="150"
      />

      <rest-list-column-enum
        prop="environment"
        :title="$t('Action_Field_Environment')"
        :enum="PushEnvironmentLabel"
        :min-width="150"
      />

      <rest-list-column-enum
        prop="visible_status"
        :title="$t('Action_Field_Status')"
        :enum="ActionStatusLabel"
        :min-width="150"
        :sortable="false"
      />

      <rest-list-column-number
        prop="target_count"
        :title="$t('Action_Field_TargetCount')"
        :formatter="targetCountFormatter"
        :min-width="100"
      />

      <rest-list-column-number
        prop="sent_count"
        :title="$t('Action_Field_SentCount')"
        :min-width="100"
      />

      <rest-list-column-number
        prop="open_count"
        :title="$t('Action_Field_OpensCount')"
        :min-width="100"
      />

      <rest-list-column-number
        prop="processing_count"
        :title="$t('Action_Field_ProcessingCount')"
        :min-width="100"
      />

      <rest-list-column-actions fixed="right" v-if="$can('Message::Read')">
        <template slot-scope="scope">
          <rest-list-action
            v-if="canCancel(scope.row)"
            :click="() => cancel(scope.row)"
            :title="$t('NotificationLog_Action_Cancel')"
            icon="el-icon-circle-close"
          />

          <rest-list-action-view :route="rowViewRoute(scope.row)" />

          <rest-list-action-download
            v-if="canDownload(scope.row) && $can('UserPersonalData::Export')"
            redirect-route-name="TaskHistoryView"
            :endpoint="rowDownloadEndpoint(scope.row)"
          />

          <rest-list-action-delete
            v-if="$isRole('admin')"
            :endpoint="rowDeleteEndpoint(scope.row)"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page-new>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumnNumber from '@/common/components/rest/RestListColumnNumber'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionDownload from '@/common/components/rest/RestListActionDownload'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import { projectEndpoint, projectRoute, formatNumber } from '@/core/helpers'
import { MessageTypeLabel } from '@/common/enum/MessageTypeEnum'
import { PushActionErrorLabel } from '@/common/enum/PushActionErrorEnum'
import {
  ActionStatusLabel,
  ActionStatusEnum
} from '@/common/enum/ActionStatusEnum'
import { PushEnvironmentLabel } from '@/common/enum/PushEnvironmentEnum'
import RestApi from '@/core/services/RestApi'
import RestListPageNew from '@/common/components/rest/RestListPageNew'
import RestListAction from '@/common/components/rest/RestListAction'
import _ from 'lodash'

export default {
  name: 'NotificationListPage',

  components: {
    RestListAction,
    RestListPageNew,
    RestListColumn,
    RestListColumnDate,
    RestListColumnNumber,
    RestListColumnEnum,
    RestListColumnActions,
    RestListActionView,
    RestListActionDownload,
    RestListActionDelete
  },

  data() {
    return {
      applications: [],
      MessageTypeLabel,
      PushEnvironmentLabel,
      ActionStatusLabel,
      ActionStatusEnum
    }
  },

  created() {
    RestApi({
      method: 'get',
      url: `/projects/${this.$route.query.project_id}`
    }).then(({ data }) => {
      this.applications = data.applications.map(item => {
        return { id: item.id, name: item.name }
      })
    })
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    breadcrumbs() {
      return [
        { label: this.$t('Campaigns_Breadcrumb_Campaigns') },
        { label: this.$t('Campaigns_Breadcrumb_NotificationsLog') }
      ]
    },

    fetchEndpoint() {
      if (this.campaignId) {
        return projectEndpoint({
          method: 'get',
          url: `actions`,
          params: {
            campaign_id: this.campaignId,
            sort: '-id'
          }
        })
      } else {
        return projectEndpoint({
          method: 'get',
          url: `actions`,
          params: {
            expand: 'campaign_title',
            sort: '-id'
          }
        })
      }
    },

    applicationsList() {
      let list = {}
      this.applications.forEach(app => {
        list[app.id] = app.name
      })
      return list
    },

    pageHeight() {
      if ($('.page').height() > 500) {
        return $('.page').height() - 220
      }
      return 500
    },

    formattedMessageTypeLabels() {
      const labels = _.clone(this.MessageTypeLabel)
      // remove RCS from the enum for now
      delete labels[14]
      return labels
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'NotificationDetails',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `actions/${row.id}`
      })
    },

    rowDownloadEndpoint(row) {
      return projectEndpoint({
        method: 'get',
        url: `actions/${row.id}/export`
      })
    },

    errorMessage(row) {
      return row.error_message in PushActionErrorLabel
        ? this.$t(PushActionErrorLabel[row.error_message])
        : row.error_message
    },

    errorClass(row) {
      return row.sent_count > 0 ? 'action-warning' : 'action-error'
    },

    targetCountFormatter(value, row) {
      return row.status === ActionStatusEnum.PREPARING
        ? `> ${formatNumber(value)}`
        : formatNumber(value)
    },

    canCancel(row) {
      return [ActionStatusEnum.PREPARING, ActionStatusEnum.PROCESSING].includes(
        row.status
      )
    },

    canDownload(row) {
      // @todo temporary fix put in place until XP-11256 is resolved.
      if (row.campaign_title === null) {
        return false
      }

      return [ActionStatusEnum.SENT, ActionStatusEnum.CANCELLED].includes(
        row.status
      )
    },

    cancel(row) {
      this.$msgbox({
        title: this.$t('NotificationLog_CancelDialog_Title'),
        message: this.$t('NotificationLog_CancelDialog_Message'),
        showCancelButton: true,
        confirmButtonText: this.$t('NotificationLog_CancelDialog_Confirm'),
        cancelButtonText: this.$t('NotificationLog_CancelDialog_Cancel'),
        center: true
      }).then(() => {
        this.$refs.list.loading = true
        RestApi(
          projectEndpoint({
            method: 'post',
            url: `actions/${row.id}/cancel`
          })
        )
          .then(() => {
            this.$message({
              message: this.$t('NotificationLog_CancelDialog_SuccessMessage'),
              type: 'success'
            })
            this.$refs.list.refresh()
          })
          .catch(error => {
            this.$refs.list.loading = false
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/notifications-log/pages/NotificationListPage.vue